import { redDark } from '@edulastic/colors'
import React from 'react'
import styled from 'styled-components'

const BorderedErrorMessage = ({ message }) => {
  return <ErrorMessage>{message}</ErrorMessage>
}

const ErrorMessage = styled.div`
  color: ${redDark};
  margin-top: 15px;
  border: 1px solid ${redDark};
  border-radius: 5px;
  padding: 10px;
`
export default BorderedErrorMessage
